<template>
  <div class="component-product-type">
    <span v-if="internalValue.is_service" class="label product-service">Prestation / Service</span>
    <span v-if="!internalValue.is_service && internalValue.parent_id === null && internalValue.type == 'product'" class="label product">Produit</span>
    <span v-if="!internalValue.is_service && internalValue.parent_id === null && internalValue.type == 'template'" class="label product-template">Template de produit</span>
    <span v-if="!internalValue.is_service && internalValue.parent_id !== null" class="label product-variant">Variante de produit</span>
  </div>
</template>

<script>
    export default {
        name: 'ProductType',
        props: ['value'],
        data: function () {
            return {
                internalValue: null,
            }
        },
        created: function() {
            this.internalValue = this.value;
        },
        watch: {
            'value'(newVal, oldVal) {
                if(typeof newVal === "undefined"){
                    newVal = 0;
                }
                this.internalValue = newVal;
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/ProductType.vue